export default __webpack_public_path__ + "static/perroquet-fond-categories-intro-852b549d221a04e0bd606d4c0da8fae3.jpg";